import { useState } from "react";
import { QueueTable } from "../components/Queue";
import type { QueueItem, QueueTask } from "../components/Queue";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 일감 › 대기열의 부품(t-in-port-work-queue) ══
   다음 차례 · 집을 수 있음 · 사유별 기다림 · 모르는 사유 코드 · 빈 상태. 서버를 안 부른다. */

const T = (id: string, title: string, extra: Partial<QueueTask> = {}): QueueTask =>
  ({ id, title, status: "ready", projectId: "in.b3x.app", repositoryIds: ["b3x-in"], agentRequestedAt: "2026-10-28T00:00:00Z", ...extra }) as QueueTask;

const ROWS: QueueItem[] = [
  { task: T("t-q1", "로그 뷰어 필터 줄 정리"), track: "run", skip: null }, // copy-ignore: 견본 자료
  { task: T("t-q2", "세션 채팅 스크롤 고정", { repositoryIds: ["b3x-in", "mops-cmmn-code"] }), track: "review", skip: null }, // copy-ignore: 견본 자료
  { task: T("t-q3", "배포 키 정하기"), track: null, skip: "deps" }, // copy-ignore: 견본 자료
  { task: T("t-q4", "GPU 리뷰", { projectId: null, repositoryIds: [], agentRequestedAt: null }), track: null, skip: "needs-tag", needs: ["gpu"] }, // copy-ignore: 견본 자료
  { task: T("t-q5", "새 사유"), track: null, skip: "future-code" }, // copy-ignore: 견본 자료
];

export function QueueStates() {
  const [why, setWhy] = useState(true);
  return (
    <>
      <h3>{tx("pat.queue.rows")}</h3>
      <button type="button" className={`b-chip${why ? " is-on" : ""}`} aria-pressed={why} onClick={() => setWhy((v) => !v)}>
        {tx("queue.why.toggle")}
      </button>
      <QueueTable rows={ROWS} projectName={(id) => (id === "in.b3x.app" ? "b3x-in" : (id ?? ""))} why={why} busy={false} onMove={() => undefined} />
      <h3>{tx("pat.queue.empty")}</h3>
      <QueueTable rows={[]} projectName={() => ""} why={false} busy={false} onMove={() => undefined} />
    </>
  );
}
